export enum AuditActionType {
  SHIPMENT = 'SHIPMENT',
  TRUCK = 'TRUCK',
  DRIVER = 'DRIVER'
}
